
class Events {
    sendEvent(eventName: string, data: any): void {
        const myEvent = new CustomEvent(eventName, {
            detail: data,
            bubbles: true,
            cancelable: true,
            composed: false,
        });

        document.dispatchEvent(myEvent);
    }

    on(eventName: string, callback: Function): void {
        document.addEventListener(eventName, (event) => callback(event));
    }

    onWindow(eventName: string, callback: Function): void {
        window.addEventListener(eventName, (event) => callback(event));
    }
}

export default Events;